
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest,
  HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ToolsService } from '../tools/tools.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(

    private tools: ToolsService,
    public translate: TranslateService
  ) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap(
      (event: HttpEvent<any>) => { },
      (err: any) => {
        console.error('err', err)

        if (err instanceof HttpErrorResponse) {
          if (err.status != 200) {
            this.tools.openSnackBar(this.translate.instant('errorServor', { statut: err.status }), 'warn', 10000);
          }
          return;
        }
      }
    ));

  }



}